<mat-toolbar>
  <button mat-icon-button (click)="clickMenu()">
    <mat-icon>menu</mat-icon>
  </button>
  <img class="cursor" class="max-h-[40px]" [src]="logo" alt="contler" />
  <div class="flex-grow"></div>
  <ng-content> </ng-content>
  <button mat-button [matMenuTriggerFor]="menuLanguage">
    <span>
      {{ actualLanguage?.name }}
    </span>
  </button>

  <mat-menu #menuLanguage="matMenu">
    @for (lan of languages; track lan.code) {
      <button mat-menu-item (click)="changeLang(lan)">
        {{ lan?.name }}
      </button>
    }
  </mat-menu>
</mat-toolbar>
